import http from "@/services/http";
import { LOGS_LIST_URL} from "@/services/endpoints";

export function getLogList(params) {
  return http.request({
    url:LOGS_LIST_URL,
    method:'get',
    params
  })
}
